module.exports = __webpack_public_path__ + "img/ggtttt.531e65db.png";